import Combiners from "abusesa-js/combiners";
import CombinerModel from "abusesa-js/ui/CombinerModel";

import FakeEvent from "./FakeEvent";

const COMBINERS = Symbol("combiners");
const ITEMS = Symbol("items");

export default class DataArray {
    constructor(combiners = {"": new Combiners.Dummy()}, items = []) {
        this[COMBINERS] = combiners;
        this[ITEMS] = [];
        this.push(...items);
        Object.defineProperty(this, "items", {enumerable: true, get: () => this[ITEMS]});
    }

    [Symbol.iterator] () {
        return this[ITEMS][Symbol.iterator]();
    }

    get length() {
        return this[ITEMS] ? this[ITEMS].length : 0;
    }

    push(...items) {
        return this[ITEMS].push(...items);
    }

    combineWith(combiners) {
        let model = new CombinerModel(new Combiners.Group(combiners), false);

        this[ITEMS].forEach(item => model.insert({event: new FakeEvent(item)}));

        model.commit();

        const collapsed = new DataArray(combiners);
        model.forEachRow(function(row) {
            let obj = {};
            model.columns().map(function(column) {
                obj[column.column] = model.renderer("text", column).render(row);
            });
            collapsed.push(obj);
        });

        return collapsed;
    }

    collapse(key = "group") {
        let comb = {};
        let combiners = this[COMBINERS];

        Object.keys(combiners).forEach(_key => {
            const combiner = combiners[_key],
                header = combiner.header(combiner.columns()[0]);

            if (key === _key || combiner instanceof Combiners.Dummy) {
                comb[_key] = new Combiners.Dummy();
            } else if (combiner instanceof Combiners.Sum || combiner instanceof Combiners.Count) {
                comb[_key] = new Combiners.Sum(header, {
                    "header": header
                });
            } else {
                comb[_key] = new Combiners.Unique(header);
            }
        });

        return this.combineWith(comb);
    }

    forEach(...args) {
        return this[ITEMS].forEach(...args);
    }

    filter(...args) {
        return new DataArray(this[COMBINERS], this[ITEMS].filter(...args));
    }

    map(...args) {
        return new DataArray(this[COMBINERS], this[ITEMS].map(...args));
    }

    slice(...args) {
        return new DataArray(this[COMBINERS], this[ITEMS].slice(...args));
    }

    sort(...args) {
        return new DataArray(this[COMBINERS],  this[ITEMS].slice().sort(...args));
    }

    reverse(...args) {
        return new DataArray(this[COMBINERS], this[ITEMS].slice().reverse());
    }

    values(key) {
        let keyName = this.keys(key);
        return key === void 0 ? this[ITEMS].slice() : this[ITEMS].map(item => item[keyName]);
    }

    keys(key) {
        let combiners = this[COMBINERS];
        return Object.keys(combiners)
            .filter(_key => _key == key || key === void 0)
            .map(_key => combiners[_key])
            .map(combiner => combiner.header(combiner.columns()))
            .map(_key => "" + _key);
    }
}


// WEBPACK FOOTER //
// ./src/kpi/lib/DataArray.js